import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldErrorMessagesModule } from '../field-error-messages/field-error-messages.module';
import { TranslateModule } from '@ngx-translate/core';
import { CarrierSelectComponent } from './carrier-select.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [CarrierSelectComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FieldErrorMessagesModule,
    TranslateModule,
    MatAutocompleteModule,
    SvgIconModule,
  ],
  exports: [CarrierSelectComponent],
})
export class CarrierSelectModule {}
